import React from 'react'
import { I18nHtml } from 'shared'

export const GiftInfo = ({ enabled }: { enabled?: boolean }) => {
  if (!enabled) return null
  return (
    <div className="my-6">
      <I18nHtml as="p" i18nKey="donate.gift_info" />
    </div>
  )
}
